import { Link } from "react-router-dom";

const services = [
  {
    icon: "ri-music-2-line",
    color: "#ff6eb4",
    gradient: "from-[#ff6eb4]/10 to-transparent",
    border: "border-[#ff6eb4]/20",
    title: "K-POP 아이돌 IP",
    desc: "좋아하는 아이돌의 뮤직비디오 신과 안무 영상을 AI로 직접 제작하세요. 공식 IP를 활용해 팬 크리에이터로 활동하세요.",
    link: "/quests",
    linkLabel: "아이돌 캠페인 도전",
    features: ["뮤직비디오 신 제작", "안무 영상 제작", "아이돌 공식 IP 활용"],
  },
  {
    icon: "ri-tv-2-line",
    color: "#3d9be9",
    gradient: "from-[#3d9be9]/10 to-transparent",
    border: "border-[#3d9be9]/20",
    title: "드라마 제작사 IP",
    desc: "인기 드라마의 명장면을 재현하고, 스핀오프 신과 OST 뮤직비디오를 AI로 제작하세요. 드라마 팬 크리에이터가 되어보세요.",
    link: "/quests",
    linkLabel: "드라마 캠페인 도전",
    features: ["명장면 재현", "스핀오프 신 제작", "OST 뮤직비디오"],
  },
  {
    icon: "ri-movie-2-line",
    color: "#e84545",
    gradient: "from-[#e84545]/10 to-transparent",
    border: "border-[#e84545]/20",
    title: "영화 제작사 IP",
    desc: "영화 포스터, 예고편 핵심 신, 명장면을 AI로 제작하세요. 영화 IP를 활용한 창작물로 팬 커뮤니티에서 주목받으세요.",
    link: "/quests",
    linkLabel: "영화 캠페인 도전",
    features: ["영화 포스터 제작", "예고편 신 제작", "명장면 재현"],
  },
  {
    icon: "ri-book-open-line",
    color: "#ff8c42",
    gradient: "from-[#ff8c42]/10 to-transparent",
    border: "border-[#ff8c42]/20",
    title: "웹툰 스튜디오 IP",
    desc: "웹툰 캐릭터를 실사 영상으로 살려내고, 애니메이션 신과 캐릭터 포스터를 AI로 제작하세요. 웹툰 팬 크리에이터로 활동하세요.",
    link: "/quests",
    linkLabel: "웹툰 캠페인 도전",
    features: ["실사 영상화", "애니메이션 신", "캐릭터 포스터"],
  },
];

const stats = [
  { value: "99만+", label: "활성 팬 크리에이터", icon: "ri-user-heart-line" },
  { value: "6개", label: "엔터테인먼트 IP", icon: "ri-sparkling-line" },
  { value: "36만+", label: "제작된 영상 & 포스터", icon: "ri-film-line" },
  { value: "4개", label: "IP 카테고리", icon: "ri-apps-line" },
];

const howItWorks = [
  { step: 1, icon: "ri-sparkling-line", color: "#ff6eb4", title: "IP 선택", desc: "K-POP, 드라마, 영화, 웹툰 중 원하는 IP를 선택하세요" },
  { step: 2, icon: "ri-sword-line", color: "#3d9be9", title: "캠페인 참여", desc: "뮤직비디오, 드라마 신, 포스터 등 캠페인을 선택하세요" },
  { step: 3, icon: "ri-ai-generate", color: "#ffd60a", title: "AI로 제작", desc: "AI 도구로 나만의 창작물을 제작하세요" },
  { step: 4, icon: "ri-share-line", color: "#ff8c42", title: "공유 & 보상", desc: "커뮤니티에 공유하고 XP를 획득하세요" },
];

export default function ServiceIntro() {
  return (
    <section className="py-20 px-6 bg-[#0a0a0f]">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-2 mb-4">
            <span className="w-6 h-6 flex items-center justify-center rounded-full bg-gradient-to-r from-[#ff6eb4] to-[#ff8c42]">
              <i className="ri-sparkling-fill text-white text-xs" />
            </span>
            <span className="text-[#ff6eb4] text-xs font-semibold tracking-widest uppercase">How It Works</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4 leading-tight">
            K-POP부터 드라마, 영화, 웹툰까지<br />
            <span className="bg-gradient-to-r from-[#ff6eb4] via-[#3d9be9] to-[#ff8c42] bg-clip-text text-transparent">모든 엔터테인먼트 IP 창작 플랫폼</span>
          </h2>
          <p className="text-white/50 text-base max-w-xl mx-auto leading-relaxed">
            CreatorVerse는 K-POP 아이돌, 드라마 제작사, 영화사, 웹툰 스튜디오의 공식 IP와 AI 기술을 연결해 팬 누구나 창작물을 제작할 수 있는 플랫폼입니다.
          </p>
        </div>

        {/* How It Works Steps */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-16">
          {howItWorks.map((step, i) => (
            <div key={step.step} className="relative text-center">
              {i < howItWorks.length - 1 && (
                <div className="hidden lg:block absolute top-8 left-[60%] w-[80%] h-px bg-white/10 z-0" />
              )}
              <div className="relative z-10">
                <div
                  className="w-16 h-16 flex items-center justify-center rounded-2xl mx-auto mb-4"
                  style={{ background: `${step.color}15`, border: `1px solid ${step.color}30` }}
                >
                  <i className={`${step.icon} text-2xl`} style={{ color: step.color }} />
                </div>
                <div
                  className="w-6 h-6 flex items-center justify-center rounded-full text-xs font-bold mx-auto mb-3"
                  style={{ background: step.color, color: "#0a0a0f" }}
                >
                  {step.step}
                </div>
                <h3 className="text-white font-bold text-sm mb-1">{step.title}</h3>
                <p className="text-white/40 text-xs leading-relaxed">{step.desc}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Service Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 mb-20">
          {services.map((svc) => (
            <div
              key={svc.title}
              className={`relative rounded-2xl border ${svc.border} bg-gradient-to-b ${svc.gradient} bg-[#0f0f1a] p-6 flex flex-col group hover:scale-[1.02] transition-transform duration-300`}
            >
              {/* Icon */}
              <div
                className="w-12 h-12 flex items-center justify-center rounded-xl mb-5"
                style={{ background: `${svc.color}18`, border: `1px solid ${svc.color}30` }}
              >
                <i className={`${svc.icon} text-xl`} style={{ color: svc.color }} />
              </div>

              <h3 className="text-white font-bold text-base mb-2">{svc.title}</h3>
              <p className="text-white/50 text-sm leading-relaxed mb-4 flex-1">{svc.desc}</p>

              {/* Features */}
              <ul className="flex flex-col gap-1.5 mb-5">
                {svc.features.map((f) => (
                  <li key={f} className="flex items-center gap-2 text-white/40 text-xs">
                    <span className="w-1 h-1 rounded-full flex-shrink-0" style={{ background: svc.color }} />
                    {f}
                  </li>
                ))}
              </ul>

              <Link
                to={svc.link}
                className="flex items-center gap-1.5 text-xs font-semibold transition-colors cursor-pointer whitespace-nowrap"
                style={{ color: svc.color }}
              >
                {svc.linkLabel} <i className="ri-arrow-right-line" />
              </Link>
            </div>
          ))}
        </div>

        {/* Stats Bar */}
        <div className="rounded-2xl border border-white/10 bg-white/3 p-8 mb-12">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
            {stats.map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-white/5 mx-auto mb-3">
                  <i className={`${stat.icon} text-white/60 text-base`} />
                </div>
                <div className="text-2xl md:text-3xl font-bold text-white mb-1">{stat.value}</div>
                <div className="text-white/40 text-xs">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>

        {/* CTA Banner */}
        <div className="relative rounded-2xl overflow-hidden">
          <img
            src="https://public.readdy.ai/ai/img_res/d267d7870aa2a3b2f313ba0b1f3bd578.jpg"
            alt="CTA Banner"
            className="w-full h-52 object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/60 to-black/85" />
          <div className="absolute inset-0 flex flex-col md:flex-row items-center justify-between px-8 md:px-12 gap-4">
            <div>
              <h3 className="text-white font-bold text-xl md:text-2xl mb-1">지금 바로 팬 크리에이터가 되세요</h3>
              <p className="text-white/60 text-sm">K-POP, 드라마, 영화, 웹툰 — 좋아하는 IP로 나만의 창작물을 AI로 만들어보세요</p>
            </div>
            <div className="flex items-center gap-3 flex-shrink-0">
              <Link
                to="/quests"
                className="px-6 py-2.5 rounded-full bg-gradient-to-r from-[#ff6eb4] to-[#ff8c42] text-white text-sm font-semibold whitespace-nowrap cursor-pointer hover:opacity-90 transition-opacity"
              >
                캠페인 시작하기
              </Link>
              <Link
                to="/artists"
                className="px-6 py-2.5 rounded-full border border-white/30 text-white text-sm font-medium whitespace-nowrap cursor-pointer hover:border-white/60 transition-colors"
              >
                IP 탐색하기
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
